import React from 'react'
import styled from 'styled-components'
import { Field } from 'formik'
import { media } from 'app/assets/styles'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import { fonts } from 'app/common/typography'

type Props = {
    notes: Array<{ range: string, value: string }>,
    value: string,
    handleClick: (string, string) => void
}

export const Notes = ({ notes, value, handleClick }: Props) => {
    return (
        <NotesContainer>
            {notes.map(note => (
                <StyledNote
                    key={note.value}
                    onClick={() => handleClick('note', note.value)}
                    selected={value === note.value}
                    className={note.range}>
                    <Field
                        type="radio"
                        name="note"
                        checked={value === note.value}
                        value={note.value}
                    />
                    {note.value}
                </StyledNote>
            ))}
        </NotesContainer>
    )
}

const NotesContainer = styled.ul`
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
`

const StyledNote = styled.li`
    border-radius: 50%;
    font-size: 12px;
    width: 25px;
    height: 25px;
    font-family: ${fonts.roboto};
    color: ${colors.lightGrey};
    border: 2px solid ${colors.lightGrey};
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-sizing: border-box;
    outline: 0;
    &.mad {
        ${props =>
            props.selected
                ? `color: ${oldColors.red};
        border-color: ${oldColors.red};`
                : ''};
    }
    &.sad {
        ${props =>
            props.selected
                ? `color: ${oldColors.orange};
        border-color: ${oldColors.orange};`
                : ''};
    }
    &.glad {
        ${props =>
            props.selected
                ? `color: ${colors.crunchyGreen};
        border-color: ${colors.crunchyGreen};`
                : ''};
    }
    input {
        -webkit-appearance: none;
        outline: 0;
        display: none;
    }
    ${media.medium`
        font-size: 20px;
        width: 60px;
        height: 60px;
    `};
`
